// The version of a forecast just before the one a report shows: the entry stepping back once in
// the report's version list lands on. Pure: no React.
import { findEntryByMoment } from "../forecast/reforecastEntries.js";

const FORECAST_KINDS = new Set(["manual", "async", "generation"]);

/**
 * The forecast entry before the shown one in `entries` (buildReforecastEntries output), or null.
 * `momentIso` null means the latest version (the live entry); resolution entries are skipped.
 *
 * @param {Array<object>|null} entries
 * @param {string|null} momentIso the report's scrubbed moment, null when latest
 * @returns {object|null}
 */
export function previousVersionEntry(entries, momentIso) {
  const list = Array.isArray(entries) ? entries : [];
  const shown =
    momentIso == null ? list.find((e) => e?.isLive) : findEntryByMoment(list, momentIso);
  const i = shown ? list.indexOf(shown) : -1;
  if (i <= 0) return null;
  for (let j = i - 1; j >= 0; j--) {
    if (FORECAST_KINDS.has(list[j]?.kind)) return list[j];
  }
  return null;
}

/**
 * A loaded version snapshot as previousForecast() shapes it ({p, at, contract}), or null.
 * @param {object|null} entry
 * @param {object|null} snap the entry's snapshot (inline for manual, fetched for async)
 */
export function asPreviousForecast(entry, snap) {
  if (!entry || !snap?.contract) return null;
  const p = snap.contract.probability;
  return {
    p: typeof p === "number" && Number.isFinite(p) ? p : null,
    at: snap.generatedAt || entry.moment || null,
    contract: snap.contract,
  };
}
